import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: 8px;
  background: #f1edff;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Stats = styled.div`
  font-size: 12px;
  color: #111827;
`;

export const Icon = styled.img`
  width: 15px;
  height: 15px;
`;

